import axiosInstance from './util/auth_util'

const CarService = {
  // 添加購物車
  async addShoppingCar(formData) {
    try {
      const response = await axiosInstance.post('/shopping_car/add', formData, {
        headers: {
            'Content-Type': 'multipart/form-data', // 显式设置表单类型
        },
      })
      return response.data
    } catch (error) {
      console.error('添加購物車失敗:', error.response.data.detail)   
      throw error.response.data.detail
    }
  },

  // 獲取購物車
  async getShoppingCar() {
    try {
      const response = await axiosInstance.get('/shopping_car/get')
      return response.data
    } catch (error) {
      console.error('獲取購物車失敗:', error)
      throw error
    }
  },

  // 更新購物車數量
  async updateItemQuantity(GoodsID, quantity){
      try{
          const response = await axiosInstance.post(`/shopping_car/update`, { GoodsID, quantity })
          return response; 
      } catch(error){
          console.log(error)
          throw error;
      }
  },

  // 刪除購物車
  async deleteShoppingCar(GoodsID) {
    try {
      const response = await axiosInstance.delete(`/shopping_car/delete/${GoodsID}`)
      return response.data
    } catch (error) {
      console.error('刪除購物車失敗:', error)
      throw error
    }
  },

}

export default CarService